import { connect } from 'react-redux'
import Table from './Table'

import onChangeTable from './Handlers/onChangeTable'
import onChangeStatus from './Handlers/onChangeStatus'

const mapStateToProps = (state) => ({
  subValuations: state.screens.SubProject.SubValuations.subValuations,
  fetching: state.screens.SubProject.SubValuations.fetching,
})

const actionCreators = {
  onChangeTable,
  onChangeStatus,
}

export default connect(mapStateToProps, actionCreators)(Table)
